<template>
  <div class="how-to">
    <h1 class="text-shadow-thin-white">{{ $t("munchen.howToPlay") }}</h1>
    <p>{{ $t("munchen.howP1") }}</p>
    <p>
      {{ $t("munchen.howP2") }}
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("munchen.howP2Highlight") }}
      </span>
    </p>
    <p>
      {{ $t("munchen.howP3") }}
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("munchen.howP3Highlight") }}
      </span>
    </p>
    <p>
      {{ $t("munchen.howP4") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "MunchenHowTo",
};
</script>
